@if (data) {
  <div class="Availability-header">
    <div class="Availability-title">{{ dialogOptions.title | uppercase }}</div>
    <div class="searchContainer" [class.isModal]="isModal()">
      <input
        class="searchBox"
        autocomplete="no-autofill"
        [formControl]="searchFormControl"
        type="search"
        [placeholder]="'admin.searchAttribute' | translate"
        />
        <mat-icon class="search">search</mat-icon>
      </div>
      @if (isModal()) {
        <div class="close-icon" (click)="onCancel()">
          <mat-icon aria-hidden="false" aria-label="Close icon">close</mat-icon>
          <span class="close-label">{{ 'shared.close' | translate }}</span>
        </div>
      }
    </div>
    <div class="availablefilters-dialog">
      <div mat-dialog-content [class.isModal]="isModal()">
        <div class="filters-catalog">
          @if (dialogOptions.message) {
            <div class="filter-message">{{ dialogOptions.message }}</div>
          }
          @if (filtersCatalog?.length === 0) {
            <div class="nodata-label">{{ 'shared.noDataToShow' | translate }}</div>
          }
          @if (filtersCatalog?.length !== 0) {
            <div class="left-side">
              @for (filterSettings of filtersCatalog; track filterSettings) {
                <div>
                  <h3 class="lbl-dialogSubHdr filter-title">{{ filterSettings.title }}</h3>
                  <div class="filter-section" [class.isModal]="isModal()">
                    @for (filter of filterSettings.filters; track filter) {
                      @if (data.options.searchMatchingAvailability ? filter.display : true) {
                        <div
                          class="filters"
                          [ngStyle]="{ 'pointer-events': isCatalogData && filter.required ? 'none' : 'all' }"
                          >
                          <mat-checkbox
                            #checkbox
                            [checked]="!!filter.checked"
                            [disabled]="(isCatalogData && filter.required) || filter.isFilterDisabled"
                            [ngClass]="{ 'p-chkbox p-chkbox-box': filterForTableView }"
                            (click)="onCkboxToggle(checkbox, filterSettings.sectionId, filterSettings.title, filter)"
                            >
                            <span [matTooltip]="filter.tooltip" matTooltipPosition="below">
                              {{ filter.value }}
                            </span>
                          </mat-checkbox>
                        </div>
                      }
                    }
                  </div>
                </div>
              }
            </div>
          }
        </div>
        @if (!filterForRecords) {
          <aside>
            <div class="selectedfilter-header">
              <div class="selectedfilter-header__title">{{ 'shared.selectedFilters' | translate }}</div>
              <div (click)="onClear()" class="selectedfilter-header__clear">{{ 'shared.clearFilters' | translate }}</div>
            </div>
            @if (userFilters?.length !== 0) {
              <div>
                @for (userFilter of userFilters; track userFilter) {
                  <div>
                    <div class="appliedfilter-title">{{ userFilter.title }}</div>
                    <mat-chip-set>
                      @for (filter of userFilter.filters; track filter) {
                        <mat-chip-option
                          class="selected-filter-option"
                          [selectable]="false"
                          [removable]="true"
                          (removed)="onRemove(userFilter.title, filter)"
                          >
                          {{ filter.value }}<mat-icon matChipRemove>cancel</mat-icon>
                          </mat-chip-option>
                        }
                      </mat-chip-set>
                    </div>
                  }
                </div>
              }
              @if (userFilters?.length === 0) {
                <div class="nofilter-label">{{ 'shared.noFiltersToSelect' | translate }}</div>
              }
            </aside>
          }
        </div>
        @if (isModal()) {
          @if (!filterForRecords) {
            <div mat-dialog-actions>
              <button class="btn-cancel-outlined" (click)="onReset()">{{ 'shared.reset' | translate }}</button>
              <button class="btn-submit" (click)="addFilters()">{{ 'shared.add' | translate }}</button>
            </div>
          }
          @if (filterForRecords) {
            <div class="availability-actions">
              @if (!isFilterDialog) {
                <button class="btn-cancel-outlined reset" (click)="resetToDefaultColumns()">
                  {{ 'shared.reset' | translate }}
                </button>
              }
              <button class="btn-submit-100" (click)="addFilters()">{{ 'shared.save' | translate }}</button>
            </div>
          }
        }
      </div>
    }
